import { Component, OnInit } from '@angular/core';
import { AuthService } from '../shared/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  currentYear: number;
  dropdownOpen:boolean=false;
   Ltype:any;
   adminsAccess:boolean=false;
  constructor(public _authService:AuthService) { }
    
  ngOnInit() 
  {
   this.currentYear = new Date().getFullYear();

   console.log(this._authService.LoginType);

   this.Ltype=this._authService.LoginType;
   if(this.Ltype=="Admin"){
     console.log("hfghfg")
   this.adminsAccess=true;
   }
  }

 
  
}
